import { api } from './api';

export interface Ntc {
  id: number;
  nombre: string;
  totalC: number;
  totalNC: number;
  totalCP: number;
  totalNA: number;
  totalRequisitos: number;
  porcentajeCumplimiento: number;
  cumpleNTC: boolean;
  ultimaActualizacion: string;
  orden: number;
}

export interface NtcsListarResponse {
  success: boolean;
  data: Ntc[];
}

export interface NtcsBatchResponse {
  success: boolean;
  ntcs: Ntc[];
}

export const ntcsService = {
  /**
   * Obtener NTCs por empresa
   */
  async listByEmpresa(nit: string): Promise<NtcsListarResponse> {
    return api.get<NtcsListarResponse>(`/empresas/${nit}/ntcs`);
  },
  /**
   * Obtener NTC por ID (UUID/código)
   */
  async getById(nit: string, ntcId: string): Promise<{ success: boolean; data: Ntc }> {
    return api.get<{ success: boolean; data: Ntc }>(`/empresas/${nit}/ntcs/${ntcId}`);
  },
};
